export default {
    showPrebuy: false,
    showThisMuch: true,
    subscribe: true,
    logicalOperatorsInGigsSearch: true,
    distance: false,
    rankGigsIncrementally: false
};